import { Category } from '../models';
import CategoryLinkAccordion from '../CategoryLinkAccordion';
import SellInMarketplaceLinkAccordion from '../SellInMarketplaceLinkAccordion';
import LoginBtn from '@components/Header/LoginArea/LoginBtn';
import LogoutBtn from '@components/Header/LoginArea/LogoutBtn';
import MyProjectsLink from '../Desktop/MyProjectsLink';
import StudioTemplatesLink from '../Desktop/StudioTemplatesLink';
import { useTemplateGalleryExperiment } from '@components/Hooks/useTemplateGalleryExperiment';
import ChangeLanguageButton from './MainScreenMenuOptions/ChangeLanguageButton';
import ContactSupportLink from './MainScreenMenuOptions/ContactSupportLink';
import GoToWixSitesLink from './MainScreenMenuOptions/GoToWixSitesLink';
import JoinMarketplaceLink from './MainScreenMenuOptions/JoinMarketplaceLink';
import useMarketplaceHeaderBi, {
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';
import s from './MobileScreens.module.scss';
import { SetActiveMobileScreenCb } from './MobileScreens';

interface Props {
  language: string;
  isUserLoggedIn: boolean;
  sortedCategories: Array<Category>;
  marketplaceUrlPrefix: string;
  pageName: string;
  keys: any;
  setActiveScreen: SetActiveMobileScreenCb;
}

const MainScreen = ({
  language,
  isUserLoggedIn,
  sortedCategories,
  marketplaceUrlPrefix,
  pageName,
  keys,
  setActiveScreen,
}: Props) => {
  const { reportClick } = useMarketplaceHeaderBi({
    pageName: pageName as IMPHeaderPageName,
  });
  const isTemplatesGalleryEnable = useTemplateGalleryExperiment();
  const enableMarketplaceTemplates = isTemplatesGalleryEnable();

  return (
    <>
      <CategoryLinkAccordion
        accordionTitle={keys.mobileServiceMenuTitle}
        categories={sortedCategories}
        marketplaceUrlPrefix={marketplaceUrlPrefix}
        pageName={pageName}
      />
      {enableMarketplaceTemplates && (
        <>
          <div className={s.linkWrapper} role="listitem">
            <StudioTemplatesLink
              label={keys.studioTemplates}
              marketplaceUrlPrefix={marketplaceUrlPrefix}
              pageName={pageName}
              isMobileView={true}
            />
          </div>
          <div className={s.divider} />
          <SellInMarketplaceLinkAccordion
            accordionTitle={keys.sellInMarketplace}
            onClick={() =>
              reportClick({
                clickType: BI_CLICK_TYPES.sellInMarketplace,
              })
            }
            items={[
              {
                text: keys.offerServices,
                onClick: () => {
                  reportClick({
                    clickType: BI_CLICK_TYPES.sellInMarketplaceOfferServices,
                  });
                  window.open(keys.offerServicesUrl, '_blank');
                },
              },
              {
                text: keys.sellStudioTemplates,
                onClick: () => {
                  reportClick({
                    clickType:
                      BI_CLICK_TYPES.sellInMarketplaceSellStudioTemplates,
                  });
                  window.open(keys.sellStudioTemplatesUrl, '_blank');
                },
              },
            ]}
            pageName={pageName}
          />
        </>
      )}
      <div className={s.divider} />
      {isUserLoggedIn && (
        <>
          <div className={s.linkWrapper} role="listitem">
            <MyProjectsLink
              label={keys.myProjects}
              marketplaceUrlPrefix={marketplaceUrlPrefix}
              pageName={pageName}
            />
          </div>
          <div className={s.divider} />
        </>
      )}
      <div className={s.linkWrapper} role="listitem">
        <ChangeLanguageButton
          language={language}
          setActiveScreen={setActiveScreen}
          pageName={pageName as IMPHeaderPageName}
        />
      </div>
      <div className={s.divider} />
      <div className={s.linkWrapper} role="listitem">
        <ContactSupportLink
          pageName={pageName as IMPHeaderPageName}
          title={keys.contactSupport}
        />
      </div>
      <div className={s.linkWrapper} role="listitem">
        <GoToWixSitesLink
          pageName={pageName as IMPHeaderPageName}
          title={isUserLoggedIn ? keys.wixSites : keys.wix}
        />
      </div>
      {!enableMarketplaceTemplates && (
        <div className={s.linkWrapper} role="listitem">
          <JoinMarketplaceLink
            title={keys.join}
            marketplaceUrlPrefix={marketplaceUrlPrefix}
            pageName={pageName as IMPHeaderPageName}
          />
        </div>
      )}
      <div className={s.mobileMenuStickBottom}>
        <div className={s.topGradient} />
        <div className={s.content}>
          <div className={s.divider} />
          <div className={s.buttons}>
            {isUserLoggedIn ? (
              <LogoutBtn
                btnSize="large"
                btnSkin="standard"
                btnLogoutLabel={keys.btnLogout}
                pageName={pageName}
              />
            ) : (
              <LoginBtn
                btnLoginLabel={keys.btnLogin}
                btnSkin="standard"
                btnSize="large"
                pageName={pageName}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainScreen;
